import React, { Component } from 'react';
import { capitalizeAndParse, capitalizeAndParseCamel } from '../../shared/utils';

import Moment from 'react-moment';

import classes from './Directory.module.css';

class Directory extends Component {
  render() {
    const baseImagePath =  '/images/portfolio';
    const useList = true;
    const baseFileUrl = this.props.url;
    const emptyFolder = this.props.files.length === 0;
    let files = this.props.files.filter(x=> x.type === 'file').map(file => {
      console.log(file)
      if(file.difficulty){
        file.diffClass = `Difficulty${file.difficulty}`
      }
      const path = `${baseFileUrl}/${file.name}`
      return <li key={file.name} className="portfolio-item">
          <a href={path} title={file.name}>
            {capitalizeAndParseCamel(file.displayName)}
          </a>
          { file.difficulty ?
            <span className={classes[file.diffClass]}>{file.difficulty}
            </span> : '' }
          <span className={classes.Size}>({file.size}kb)</span>
          <span className={classes.Date}><Moment format='LL'>{file.date}</Moment></span>
        </li>
    });

    let directories = this.props.files.filter(x=> x.type === 'directory').map(dir => {
        const path = `${baseFileUrl}/${dir.name}`
        var projectImage = baseImagePath+dir.thumb;
        return <div key={dir.name} className={classes.Columns+" portfolio-item"}>
          <li className={"item-wrap " + classes.PracticeItem}>
              <a href={path} title={dir.name}>
                      <img alt={dir.name} src={projectImage} />
                  <div className="overlay">
                      <div className="portfolio-item-meta">
                          <h5>{dir.name}</h5>
                          <p>{dir.name}</p>
                      </div>
                  </div>
                  <div className="link-icon"><i className="fa fa-link"></i></div>
                  <span>{capitalizeAndParse(dir.name)}</span>
              </a>
              
          </li>
        </div>
      });
    return (
      <section id="portfolio">

      <div className="row">
        <h1>{!emptyFolder ? this.props.header : 'Empty Folder'}</h1>
         {directories.length ? 
          <div className="twelve columns collapsed">
            <ul className={classes.DirectoryList}>{directories}</ul>
          </div>
        :''}

         {files.length ? 
          <div className="eleven columns collapsed">
            <ul className={classes.PracticeFileList}>{files}</ul>
          </div>
        :''}
      </div>
   </section>
    );
  }
}

export default Directory;
